// Loader.tsx
import React from "react";
import Lottie from "lottie-react";
import loaderAnimation from "./../../assets/img/Loading _1.json";

const Loader = () => {
    return (
        <div
            style={{
                width: "100vw",
                height: "100vh",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                backgroundColor: "fff",
            }}
        >
            <Lottie animationData={loaderAnimation} loop={true} width={"10px"} />
        </div>
    );
};

export default Loader;
